import { Injectable } from '@angular/core';
import { CookieService, CookieOptionsArgs, CookieOptions } from "angular2-cookie/core";

@Injectable()
export class CookieManagementService
{
    argsBase: CookieOptionsArgs = {};
    expireMinutes = 60;
    ignoreList: string[] = ["Redirect2"];

    constructor(private cookieService: CookieService)
    {
        let domainArray = window.location.host.match(/(\.)(.*)/g);
        if (domainArray)
            this.argsBase.domain = domainArray[0];

        this.argsBase.secure = true;
    }

    get(key: string): string
    {
        let args: CookieOptionsArgs = { ... this.argsBase };
        return this.cookieService.get(key);
    }

    getAll(): Object
    {
        return this.cookieService.getAll();
    }

    put(key: string, value: string | number | boolean, expireTime: Date = new Date((new Date()).getTime() + this.expireMinutes * 60 * 1000)): void
    {
        if (value != null)
        {
            let args: CookieOptionsArgs = { ...this.argsBase, expires: expireTime,  };
            this.cookieService.put(key, "" + value, args);
        }
        
    }

    remove(key: string): void
    {
        let args: CookieOptionsArgs = { ...this.argsBase };
        this.cookieService.remove(key, args);
    }

    removeAll(): void
    {
        let args: CookieOptionsArgs = { ...this.argsBase };
        let cookies = this.cookieService.getAll();
        Object.keys(cookies).forEach(key =>
        {
            if(this.ignoreList.indexOf(key) < 0)
                this.cookieService.remove(key, args);
        });
        this.cookieService.removeAll();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Services/cookie-management.service.ts